import { Modal } from "antd";
import { Card } from "antd";
import { ContainerModal, ItemTextModal, ItemWrapper, Title } from "../styles";
import { useEffect, useState } from "react";
import { useAtualizarCompatibilidade } from "../hooks/useAtualizarCompatibilidade";
import { useMessage } from "../../../uteis/mensagens/useMessage";

export default function ModalExcluir({
  isModalOpen,
  handleFechar,
  compatibilidadeId,
  buscarComp,
}: any) {
  const [dataCompatibilidade, setCompatibilidade] = useState<any>({});

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  const { atualizar, isLoading, error, success, resetError, resetSuccess } =
    useAtualizarCompatibilidade();

  // Exibe a Mensagem de  Erro
  const { showSuccess, showError, contextHolder } = useMessage();

  useEffect(() => {
    if (isModalOpen) {
      setCompatibilidade({ active: 0 });
    }
  }, [isModalOpen, compatibilidadeId]);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);
      // Limpa estado de sucesso após 3 segundos e recarrega a página
      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
        handleFechar();
        buscarComp();
      }, 3000);
    }
    // Exibe a mensagem de erro
    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  });

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      cancelText="Cancelar"
      okText="Excluir"
      onOk={() => atualizar(compatibilidadeId, dataCompatibilidade)}
      confirmLoading={isLoading}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        }, // Botão "Ativar" com fundo verde
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        }, // Botão "Cancelar" com fundo vermelho
      }}
    >
      <>{contextHolder}</>
      <Card
        title={<Title>Excluir Compatibilidade</Title>}
        style={{
          width: "100%",
          marginTop: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <ContainerModal>
          <ItemWrapper>
            <ItemTextModal>
              Tem certeza que gostaria de excluir esta compatibilidade?
            </ItemTextModal>
          </ItemWrapper>
        </ContainerModal>
      </Card>
    </Modal>
  );
}
